
export default {
  name: 'SVGClose',
};
